/**
 * @file 定义 vue 的全局过滤器
 * 使用时，在 mian.js 文件中进行引用
 * @version
 * @author pankzou
 * @date 2021-09-13
 * @lastModified
 * @lastModifiedDate
 *
 * @example
 * 加载模块
 * import filters from './filters/index' // 全局过滤器封装
 *
 * 在 main.js 中注册
 * for (let key in filters) {
 *  Vue.filter(key, filters[key])
 * }
 *
 * 在 .vue 文件中使用
 * {{datatime|formatDate}}
 *
 */

export default {
    /*
     * 日期格式化
     * @param {string} date - 需要的日期格式
     * @returns {string} - 符合格式的日期
     */
    formatDate(date, fmt = "yyyy-MM-dd") {
        if (date) {
            let fullDate = new Date(date.replace(/-/g, '/'));

            let o = {
                "M+": fullDate.getMonth() + 1,// 月份
                "d+": fullDate.getDate(),// 日
                "H+": fullDate.getHours(),// 小时
                "m+": fullDate.getMinutes(),// 分
                "s+": fullDate.getSeconds(),// 秒
                "q+": Math.floor((fullDate.getMonth() + 3) / 3), // 季度
                "S": fullDate.getMilliseconds()// 毫秒
            };

            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (fullDate.getFullYear() + "").substr(4 - RegExp.$1.length));
            }

            for (let k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                }
            }
            return fmt;
        } else {
            return "";
        }
    },

    /*
     * 用途：js中字符串超长作固定长度加省略号（...）处理
     * 参数说明：
     * str:需要进行处理的字符串，可含汉字
     * len:需要显示多少个汉字，两个英文字母相当于一个汉字。
     */
    beautySub(str, len) {
        if (str) {
            let reg = /[\u4e00-\u9fa5]/g, //专业匹配中文
                slice = str.substring(0, len),
                chineseCharNum = (~~(slice.match(reg) && slice.match(reg).length)),
                realen = slice.length * 2 - chineseCharNum;
            return str.substr(0, realen) + (realen < str.length ? "..." : "");
        } else {
            return "";
        }
    },
}
